import React from "react";
import { Users, Circle } from "lucide-react";

export default function ConversationListItem({ item, onClick, isOnline }) {
  return (
    <button
      onClick={onClick}
      className={[
        "w-full text-left rounded-[22px] px-4 py-3 mb-2.5 border transition-all duration-200",
        item.isActive
          ? "bg-white/[0.08] border-white/18 shadow-[0_10px_30px_rgba(0,0,0,0.28)]"
          : "bg-white/[0.02] border-white/10 hover:bg-white/[0.05] hover:border-white/15",
      ].join(" ")}
    >
      <div className="flex items-center gap-3">
        <div className="relative shrink-0">
          {item.type === "dm" ? (
            item.avatar ? (
              <img
                src={item.avatar}
                alt={item.name}
                className="h-11 w-11 rounded-2xl object-cover border border-white/12 shadow-[0_6px_16px_rgba(0,0,0,0.24)]"
              />
            ) : (
              <div className="h-11 w-11 rounded-2xl bg-white/10 border border-white/12 grid place-items-center text-white font-semibold">
                {item.name?.[0]?.toUpperCase() || "?"}
              </div>
            )
          ) : (
            <div className="h-11 w-11 rounded-2xl bg-white/[0.05] border border-white/12 grid place-items-center text-white/85">
              <Users size={16} />
            </div>
          )}

          {item.type === "dm" && (
            <Circle
              size={10}
              className={`absolute -bottom-0.5 -right-0.5 ${
                isOnline ? "fill-[#7be0ca] text-[#7be0ca]" : "fill-white/25 text-white/25"
              }`}
            />
          )}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <div className="truncate text-[13.5px] font-medium text-white/92">{item.name}</div>
            <div className="text-[11px] text-white/45">{item.timestamp}</div>
          </div>
          <div className="mt-1 flex items-center justify-between gap-2">
            <div className="truncate text-[11.5px] text-white/52">{item.preview}</div>
            {item.unread > 0 && (
              <div className="shrink-0 rounded-full bg-white/[0.09] border border-white/16 px-2.5 py-0.5">
                <span className="text-[11px] font-semibold text-white/92">
                  {item.unread > 99 ? "99+" : item.unread}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}
